import axios from "axios";

const baseUrl = process.env.REACT_APP_BASE_API;

const getOption = (method, path) => {
  const url = `${baseUrl}/${path}`;
  const headers = {
    "Content-Type": "application/json",
    Accept: "application/json",
    "Access-Control-Allow-Origin": true,
  };

  return { url, headers, method };
};

const app = {
  get: async (url) => {
    const option = getOption("GET", url);
    const { data } = await axios.request(option);
    return data;
  },
};

export default app;
